// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhn_a bib_h","Menu__offsetParent":"bhn_b bib_bj","Menu__trigger--shadowed":"bhn_c"};